module.exports = {
  name: "QUAISOFTINT S DE RL DE CV",
  rfc: "QUA230828IS6",
  address:
    "Calle Agua Marina 2890, Int. 5, Col. Agua Blanca Industrial, C.P. 45235, Zapopan, Jalisco, México",
  phone: "+52 33 1638 8068",
  whatsapp: "+34 649 890 875",
  email: "soporte@medkus.com",
};
